module.exports = __webpack_public_path__ + "static/img/wenmingxin.5c29d3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenmingxin.png
// module id = sEah
// module chunks = 1